import React from "react";
import CampusGallery from "./CampusGallery";

const BASE = "/assets/kiki/gallery";

const IMAGES = [
  { src: `${BASE}/kiki-team-group.jpg`, caption: "The team at Kiki Centre for Technology, IMT Manesar" },
  { src: `${BASE}/machine-training.jpg`, caption: "Additive-manufacturing demo · Delhi Machine Tool Expo 2025" },
  { src: `${BASE}/faculty-teaching.jpg`, caption: "German-curriculum faculty leading a classroom session" },
  { src: `${BASE}/campus-students-1.jpg`, caption: "Students at the 25,000 sq.ft. Kiki campus, Gurugram" },
  { src: `${BASE}/workshop-demo.jpg`, caption: "Live tool-room demonstration on industrial machinery" },
  { src: `${BASE}/kiki-team-women.jpg`, caption: "Faculty & mentors at Kiki Centre" },
  { src: `${BASE}/seminar-hall.jpg`, caption: "Student orientation seminar in the training hall" },
  { src: `${BASE}/campus-group.jpg`, caption: "A new batch begins at Kiki Centre for Technology" },
  { src: `${BASE}/leadership-team.jpg`, caption: "Leadership & training experts at Kiki" },
  { src: `${BASE}/classroom-session.jpg`, caption: "Interactive learning with computers & projectors" },
  { src: `${BASE}/kiki-team-partner.jpg`, caption: "With our HWK Koblenz training partner from Germany" },
  { src: `${BASE}/campus-students-2.jpg`, caption: "Students outside the Kiki campus" },
  { src: `${BASE}/medals.jpg`, caption: "Work Skills Competition medals won by Kiki students" },
];

export default function CampusGallerySection() {
  return (
    <CampusGallery
      kicker="Life at Kiki"
      title="Inside our campus"
      subtitle="Real moments from Kiki Centre for Technology — hands-on training, expert faculty, industry visits and a community that learns by doing."
      images={IMAGES}
      bg="slate"
      idPrefix="home-gallery"
    />
  );
}
